module.exports = "/_next/static/images/UDJ4-914ca1d7494cea8efba9659d8ab5d284.svg";